import { createElement } from 'react';
import { View } from 'react-native';
import { FCC } from '../utils/react';

export const PreviousNextView: FCC = ({ children, ...props }) =>
  createElement(View, props, children);

export default null;
